module.exports = __webpack_public_path__ + "static/media/failed-capture-five.a9a43ca9.png";